<script setup lang="ts">

import { Badge } from "@/components/ui/badge";

type MaintenanceRecordStatus = {
  value:  'planned' | 'in_progress' | 'done' | 'blocked',
  label: string,
}
defineProps<{
  status: MaintenanceRecordStatus,
}>();
</script>

<template>
  <Badge :variant="{
    planned: 'zinc',
    in_progress: 'yellow',
    done: 'green',
    blocked: 'red',
  }[status.value]">
    {{ status.label }}
  </Badge>
</template>